import React from 'react';
import { AlertCircle } from 'lucide-react';

export default function FieldError({ error, className = '' }) {
  if (!error) return null;
  return (
    <p className={`flex items-center gap-1 mt-1 text-xs text-red-600 ${className}`}>
      <AlertCircle className="h-3 w-3 shrink-0" />
      <span>{error}</span>
    </p>
  );
}
